import { useEffect, useRef, useState } from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import ReactLoaderSpinner from "react-loader-spinner";

export default function OverflowToolbar({ items = [] }) {
    const containerRef = useRef(null);
    const [overflowItems, setOverflowItems] = useState([]);

    const visibleItems = items.filter(item => !item.hide);

    const handleClick = (item, e) => {
        if (item?.disabled) {
            return;
        }

        if (typeof item.onClick === "function") {
            item.onClick(e);
        }
    };

    useEffect(() => {
        if (!containerRef.current) return;

        const updateLayout = () => {
            requestAnimationFrame(() => {
                const el = containerRef.current;

                if (!el) return;

                const maxWidth = el.clientWidth - 100; // فضای دکمه سایر عملیات

                const btnElements = el.querySelectorAll(".toolbar-btn");

                const newOverflow = [];
                let sumWidth = 0;

                btnElements.forEach((btn, index) => {
                    const item = visibleItems[index];

                    if (!item) return;

                    // ابتدا همه دکمه‌ها را نمایش بده تا عرض واقعی آنها محاسبه شود
                    btn.style.display = "inline-flex";

                    const btnWidth = btn.offsetWidth;

                    sumWidth += btnWidth + 5; // 5px gap

                    if (sumWidth > maxWidth) {
                        btn.style.display = "none";
                        newOverflow.push(item);
                    }
                });

                setOverflowItems(newOverflow);
            });
        };

        const observer = new ResizeObserver(updateLayout);

        observer.observe(containerRef.current);

        updateLayout();

        return () => observer.disconnect();
    }, [items]);

    const renderPopDiv = (item, index) => {
        return (
            <div
                className={`popMenuItem ${item.disabled ? "disabled-pop" : ""}`}
                key={item.key || index}
                onClick={(e) => handleClick(item, e)}
            >
                {item.icon && <span>{item.icon}</span>}
                {item.label && <span>{item.label}</span>}
            </div>
        );
    };

    const popMenu = (
        <Popover id="popMenu" style={{ fontFamily: "Vazir" }}>
            <Popover.Title
                className="headerStyle"
                style={{ paddingRight: "2px" }}
            >
                <List size={18} /> سایر عملیات
            </Popover.Title>

            <Popover.Content
                className="bodyStyle"
                style={{ padding: "2px" }}
            >
                {overflowItems.map((item, index) =>
                    item.overlay ? (
                        <OverlayTrigger
                            key={item.key || index}
                            placement={item.placement || "top"}
                            overlay={item.overlay}
                            trigger={item.trigger || "click"}
                            rootClose={item.rootClose || false}
                        >
                            {renderPopDiv(item, index)}
                        </OverlayTrigger>
                    ) : (
                        renderPopDiv(item, index)
                    )
                )}
            </Popover.Content>
        </Popover>
    );

    const renderButton = (item, index) => {
        return (
            <Button
                type={item.type || "button"}
                disabled={item.disabled || item.loading || false}
                key={item.key || index}
                variant={item.variant || "primary"}
                className={`group-Btn toolbar-btn ${item.className ?? ""}`}
                onClick={(e) => handleClick(item, e)}
                style={{
                    display: "inline-flex",
                    gap: "1px",
                    alignItems: "center",
                    flexShrink: 0
                }}
            >
                {item.loading && (
                    <ReactLoaderSpinner
                        type="TailSpin"
                        color="green"
                        width={16}
                        height={16}
                        style={{ display: "inline-block" }}
                    />
                )}

                {item.icon && !item.loading && (
                    <span>{item.icon}</span>
                )}

                {item.label && (
                    <span>{item.label}</span>
                )}
            </Button>
        );
    };

    return (
        <div
            ref={containerRef}
            style={{
                display: "flex",
                gap: "5px",
                overflow: "hidden",
                paddingBottom: "5px"
            }}
        >
            {visibleItems.map((item, index) =>
                item.overlay ? (
                    <OverlayTrigger
                        key={item.key || index}
                        overlay={item.overlay}
                        trigger={item.trigger || "click"}
                        placement={item.placement || "top"}
                    >
                        {renderButton(item, index)}
                    </OverlayTrigger>
                ) : (
                    renderButton(item, index)
                )
            )}

            {overflowItems.length > 0 && (
                <OverlayTrigger
                    trigger="click"
                    rootClose
                    overlay={popMenu}
                >
                    <Button className="group-Btn btn-violet">
                        <List size={18} />
                    </Button>
                </OverlayTrigger>
            )}
        </div>
    );
}